import { gql } from '@apollo/client';

export const NOTIFY_COORDINATOR = gql`
    mutation notifyCoordinator($eventId: Int!, $origin: String!) {
        notifyCoordinator(eventId: $eventId, origin: $origin) {
            status
        }
    }
`;
